(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuStatusVoipController', OnuStatusVoipController);

    OnuStatusVoipController.$inject = ['$uibModalInstance', 'AlertModalService', 'OnuService', 'idOnu'];

    function OnuStatusVoipController($uibModalInstance, AlertModalService, OnuService, idOnu) {

        var vm = this;

        vm.statusVoipList = [];

        // Flag to avoid closing modal when request is running
        vm.requestRunning = false;

        // Form Actions
        vm.init = init;
        vm.reload = reload;
        vm.close = close;
        vm.getStatusVoip = getStatusVoip;
        vm.setStatusVoip = setStatusVoip;

        function init() {
            getStatusVoip();
        }

        function reload() {
            getStatusVoip();
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function getStatusVoip() {
            OnuService.getONTStatusVoip(idOnu).then(function (data) {
                vm.setStatusVoip(data);
            })
                    .catch(function (error) {
                        AlertModalService.errorWithMsg("onuStatusVoip.onuOff");
                        vm.close();
                    });
        }

        function setStatusVoip(data) {
            vm.statusVoipList = data;
            vm.statusVoipList.forEach(function (element) {
                element.phoneNumber = element.phoneNumber != null ? element.phoneNumber : '--';
                element.registrationStatus = element.registrationStatus != null ? element.registrationStatus : '--';
                element.callStatus = element.callStatus != null ? element.callStatus : '--';
            });

        }

    }
})();